const initialState = {
  authen: {
    registeredUser: null,
    loggedInUser: null,
  },
  apiCallsInProgress: 0,
};
export default initialState;
